/**
 * @license
 * Copyright© Celligence International, LLC - 2023
 * This software program is protected by copyright laws and is the property of
 * Celligence International, LLC (Celligence). Any unauthorized reproduction,
 * distribution, modification, or public display of this program, without the
 * explicit permission of Celligence is strictly prohibited. If you have gained
 * access to this program without the expressed approval of Celligence report
 * the incident to legal@celligence.com.
 */
import React, { lazy, Suspense, useState, useEffect } from "react";
import { Container, Row, Col, Button } from "react-bootstrap";
import "./Body.css";
import content from '../content.json';
import parse from 'html-react-parser';
import { useParams } from 'react-router-dom';
import Contactus from "../ContactUs/Contactus.js";
import axios from "axios";
export default function Banner({ dataJson }) {


  const imgCDNURL = process.env.REACT_APP_VASTREAMLINE_PROGRAM_CDN_URL;
  // const loInfo = loData.find(lo => lo.url === loName);
  const [loInfo, setLoInfo] = useState(null); // Initialize loInfo as null
  const [loanOfficerUid, setLoanOfficerUid] = useState('');
  const { loName } = useParams();
  const { agentName } = useParams();
  const agentJsonName = agentName + ".json";
  const [loading, setLoading] = useState(true);
  const [loadBodyData, setLoadBodyData] = useState(true);
  const [agentData, setAgentData] = useState();
  const [loanOfficerActive, setLoanOfficerActive] = useState(true);
  const [loanOfficerData, setLoanOfficerData] = useState();
  const [realorData, setRealtorData] = useState();
  const [aiBrandingData, setAiBrandingData] = useState();
  const [angelAiUserInfo, setAngelAiUserInfo] = useState();
  const [data, setData] = useState(null); // Set initial state as null





  useEffect(() => {

    const fetchAiBrandingJson = async () => {
      try {
        await axios
          .get(process.env.REACT_APP_ANGELAI_JSON)
          .then((response) => {
            // console.log(JSON.stringify(response.data));
            setAiBrandingData(response.data);
          })
          .catch((error) => {
            console.log(error);
          });
      } catch (e) {
        console.log(e);
      }
    };

    /**
     * Fetches the Angel AI user info from the specified endpoint.
     *
     * @return {Promise<void>} - A Promise that resolves when the user info has been fetched successfully.
     */
    const fetchAngelAiUserInfo = async () => {
      try {
        await axios
          .get(process.env.REACT_APP_ANGEL_AI_WEB_USER_INFO)
          .then((response) => {
            // console.log(JSON.stringify(response.data));
            setAngelAiUserInfo(response.data);
          })
          .catch((error) => {
            console.log(error);
          });
      } catch (e) {
        console.log(e);
      }
    };

    /**
     * Checks if a loan officer is active.
     *
     * @param {string} loanOfficerId - The ID of the loan officer.
     * @return {Promise<void>} A promise that resolves when the function completes.
     */
    const checkifLoanOfficerIsActive = async (loanOfficerId) => {
      try {
        await axios
          .post(process.env.REACT_APP_CHECK_LO_ACTIVE, {
            loanOfficerId: loanOfficerId,
          })
          .then((response) => {
            // console.log(JSON.stringify(response.data));
            setLoanOfficerActive(response.data.active);
          })
          .catch((error) => {
            console.log(error);
          });
      } catch (e) {
        console.log(e);
      }
    };
    const fetchAgentDetails = async () => {
      try {
        await axios
          .get(
            process.env.REACT_APP_CDN +
            "mlo-product-guidelines/jsons/" +
            agentJsonName
          )
          .then(async (response) => {
            // console.log(JSON.stringify(response.data));
            const responseData = response.data;
            setAgentData(responseData);
            await fetchAiBrandingJson();
            if (responseData) {
              setLoading(false);
              const loanOfficerId = responseData.staff.loanOfficer.ssid;
              await checkifLoanOfficerIsActive(loanOfficerId);
              await fetchAngelAiUserInfo();
              setLoanOfficerData(responseData.staff.loanOfficer);
              setRealtorData(responseData.staff.realtor);
              setLoadBodyData(false);
            }
          })
          .catch((error) => {
            window.location.replace("https://www.swmc.com");
          });
      } catch (e) {
        console.log(e);
      }
    };

    fetchAgentDetails();
  }, []);

  const realtorLoId = loanOfficerData ? loanOfficerData.ssid : "";

  const handleClick = () => {
    window.open(`https://www.swmc.com/ApplyNow/?lof=${realtorLoId}`, '_blank');
  };

  const { title, title2, title3, titleMobile, title2Mobile, title3Mobile, btnName, para } = dataJson;

  return (
    <>
      <div className="banner">
        <Container>
          <Row className="banner-row">
            <Col sm={12} md={12} lg={7} className='welcome-col'>

              <h2 className='title2'>{parse(title2)}</h2>
              <h2 className='title2Mobile'>{parse(title2Mobile)}</h2>
              <h2 className='title3'> {parse(title3)}</h2>
              <h2 className='title3Mobile'>{parse(title3Mobile)}</h2>

              <p className='para'>{parse(para)}</p>
              <h1 className='titleMobile'>{parse(titleMobile)}</h1>
              <div class="container">
                <h1 className='title'>{parse(title)}</h1>
                <img src={imgCDNURL + "curveimage.webp"} className='curveimage' alt="curveimage"
              loading="lazy"
              width={""}
              height={""}></img>
                <div className="bannerbuttondiv">
                  <Button variant="primary" className="applyNowBtnbanner" onClick={handleClick}>
                    <p className="applyNowBtntext">Apply Now</p>
                  </Button>
                </div>
              </div>


            </Col>
            {/* <Col sm={12} md={12} lg={1} className='welcome-col'></Col> */}
            <Col sm={12} md={12} lg={5} className='welcome-col'>
              <Suspense fallback={<div />}>
                <Contactus
                  realtorData={realorData}
                  loanOfficerActive={loanOfficerActive}
                  loanOfficerData={loanOfficerData}
                  angelAiUserInfo={angelAiUserInfo} />
              </Suspense>
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
}
